import React, { useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/UserPersonalInfo.css';
import ButtonRegular from './ui/ButtonRegular';
import ButtonDelete from './ui/ButtonDelete';

function UserPersonalInfo({ userDetails }) {
	const { logout } = useContext(AuthContext);
	const navigate = useNavigate();

	const [isEditing, setIsEditing] = useState(false);
	const [changePassword, setChangePassword] = useState(false);
	const [message, setMessage] = useState('');
	const [showDelete, setShowDelete] = useState(false);
	const [deletePassword, setDeletePassword] = useState('');

	const [formData, setFormData] = useState({
		firstName: userDetails.firstName || '',
		lastName: userDetails.lastName || '',
		email: userDetails.email || '',
		phone: userDetails.phone || ''
	});

	const [passwordData, setPasswordData] = useState({
		oldPassword: '',
		newPassword: '',
		confirmPassword: ''
	});

	const handleChange = (e) => {
		setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
	};

	const handlePasswordChange = (e) => {
		setPasswordData(prev => ({ ...prev, [e.target.name]: e.target.value }));
	};

	const validatePhone = (phone) => /^\+?\d{7,15}$/.test(phone);

	const validateNewPassword = (password) =>
		/^(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/.test(password);

	const handleLogout = () => {
		logout();
		navigate('/login');
	};

	const handleSave = async () => {
		if (!validatePhone(formData.phone)) {
			setMessage('Nieprawidłowy numer telefonu.');
			return;
		}

		const token = localStorage.getItem('authToken');

		try {
			await axios.put(
				`${process.env.REACT_APP_API_URL}/api/users/update`,
				{
					firstName: formData.firstName,
					lastName: formData.lastName,
					phone: formData.phone
				},
				{
					headers: { Authorization: `Bearer ${token}` }
				}
			);

			setMessage('Zapisano zmiany.');
			setIsEditing(false);
		} catch {
			setMessage('Błąd podczas zapisu.');
		}
	};

	const handlePasswordSubmit = async (e) => {
		e.preventDefault();

		const { oldPassword, newPassword, confirmPassword } = passwordData;

		if (newPassword !== confirmPassword) {
			setMessage('Nowe hasła nie są identyczne.');
			return;
		}

		if (!validateNewPassword(newPassword)) {
			setMessage('Hasło musi mieć min. 8 znaków, 1 wielką literę, cyfrę i znak specjalny.');
			return;
		}

		const token = localStorage.getItem('authToken');

		try {
			await axios.put(
				`${process.env.REACT_APP_API_URL}/api/users/password`,
				{ oldPassword, newPassword },
				{ headers: { Authorization: `Bearer ${token}` } }
			);

			setMessage('Hasło zostało zmienione.');
			setPasswordData({ oldPassword: '', newPassword: '', confirmPassword: '' });
			setChangePassword(false);
		} catch {
			setMessage('Błąd podczas zmiany hasła.');
		}
	};

	const handleDeleteAccount = async () => {
		if (!deletePassword) {
			setMessage('Podaj hasło, aby usunąć konto.');
			return;
		}

		if (!window.confirm('Czy na pewno chcesz usunąć konto? Tej operacji nie można cofnąć!')) {
			return;
		}

		const token = localStorage.getItem('authToken');

		try {
			await axios.delete(
				`${process.env.REACT_APP_API_URL}/api/users/delete/${userDetails._id}`,
				{
					data: { password: deletePassword },
					headers: { Authorization: `Bearer ${token}` }
				}
			);

			logout();
			navigate('/login');
		} catch (err) {
			setMessage(err.response?.data?.message || 'Błąd podczas usuwania konta.');
		}
	};

	return (
		<div className="user-info-container">
			<h2 className="profile-title">Twój profil</h2>

			<div className="user-info-card">
				{isEditing ? (
					<>
						<label>Imię
							<input name="firstName" value={formData.firstName} onChange={handleChange} />
						</label>

						<label>Nazwisko
							<input name="lastName" value={formData.lastName} onChange={handleChange} />
						</label>

						<label>Email
							<input name="email" value={formData.email} readOnly />
						</label>

						<label>Telefon
							<input name="phone" value={formData.phone} onChange={handleChange} />
						</label>

						<div className="button-row">
							<ButtonRegular className="profile-btn" onClick={handleSave}>
								Zapisz
							</ButtonRegular>

							<ButtonRegular className="profile-btn ghost" onClick={() => setIsEditing(false)}>
								Anuluj
							</ButtonRegular>
						</div>
					</>
				) : (
					<>
						<p><strong>Imię:</strong> {formData.firstName}</p>
						<p><strong>Nazwisko:</strong> {formData.lastName}</p>
						<p><strong>Email:</strong> {formData.email}</p>
						<p><strong>Telefon:</strong> {formData.phone}</p>

						<div className="button-row">
							<ButtonRegular className="profile-btn" onClick={() => setIsEditing(true)}>
								Edytuj dane
							</ButtonRegular>
						</div>
					</>
				)}
			</div>

			<div className="user-info-card buttons-card">
				{!changePassword ? (
					<ButtonRegular className="profile-btn" onClick={() => setChangePassword(true)}>
						Zmień hasło
					</ButtonRegular>
				) : (
					<form onSubmit={handlePasswordSubmit} className="password-change-form">
						<label>Stare hasło
							<input type="password" name="oldPassword" value={passwordData.oldPassword} onChange={handlePasswordChange} required />
						</label>

						<label>Nowe hasło
							<input type="password" name="newPassword" value={passwordData.newPassword} onChange={handlePasswordChange} required />
						</label>

						<label>Powtórz nowe hasło
							<input type="password" name="confirmPassword" value={passwordData.confirmPassword} onChange={handlePasswordChange} required />
						</label>

						<div className="button-row">
							<ButtonRegular className="profile-btn" type="submit">
								Zapisz nowe hasło
							</ButtonRegular>

							<ButtonRegular className="profile-btn ghost" type="button" onClick={() => setChangePassword(false)}>
								Anuluj
							</ButtonRegular>
						</div>
					</form>
				)}

					<ButtonRegular className="profile-btn" onClick={handleLogout}>
						Wyloguj się
					</ButtonRegular>

				{!showDelete ? (
						<ButtonDelete className="profile-btn-danger" onClick={() => setShowDelete(true)}>
							Usuń konto
						</ButtonDelete>
				) : (
					<>
						<label>Podaj hasło
							<input
								type="password"
								value={deletePassword}
								onChange={(e) => setDeletePassword(e.target.value)}
							/>
						</label>

						<div className="button-row">
							<ButtonDelete className="profile-btn-danger" onClick={handleDeleteAccount}>
								Usuń konto
							</ButtonDelete>

							<ButtonRegular
								className="profile-btn ghost"
								onClick={() => {
									setShowDelete(false);
									setDeletePassword('');
								}}
							>
								Anuluj
							</ButtonRegular>
						</div>
					</>
				)}
			</div>

			{message && <p className="info-message">{message}</p>}
		</div>
	);
}

export default UserPersonalInfo;
